import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
	Box,
	Button,
	Container,
	Typography,
	Divider,
	TextField,
	Menu,
	MenuItem,
	Checkbox,
	FormControlLabel,
	FormGroup,
	Autocomplete,
	Chip,
	InputAdornment,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	IconButton,
} from "@mui/material";

import ClustersTable from "./ClustersTable";
import { useAuth } from "../../helpers/AuthProvider";
import queryGraphql from "../../helpers/ApiInterface";
import { ExpandMore } from "@mui/icons-material";
import MainDrawer from "../MainDrawer";
import MiniBot from "../MiniBot";
interface SearchOptions {
	chipLabel: string;
	dropdownLabel: string;
	category: string;
	groupBy: string;
}

let searchOptions: SearchOptions[] = [];
const ClusterPage: React.FC = () => {
	const [clusters, setClusters] = useState([]);
	const { user } = useAuth();
	const navigate = useNavigate();
	const [searchQuery, setSearchQuery] = useState<SearchOptions[]>([]);
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const [expanded, setExpanded] = useState(true);
	const [addClusterMenuAnchorEl, setAddClusterMenuAnchorEl] = useState<null | HTMLElement>(null); // State for Add Cluster Menu
	// const isClusterOwnerOrAdmin =
	// 	user.roles.some((e: string) => ["cluster_owner", "idp_admin"].includes(e)) || false;
	const isClusterOwner = user.roles.some((e: string) => ["cluster_owner","viewer"].includes(e)) || false;
	const [columnFilters, setColumnFilters] = useState<Record<string, boolean>>({
		clusterName: true,
		environment: true,
		region: true,
		gcpProjectId: true,
		clusterOwner: true,
		applications: true,
		createdAt: true,
	});
	const [updates, setUpdates] =  useState<any>([]);
   // Helper variable for the Add Cluster Menu's open state
  const isAddClusterMenuOpen = Boolean(addClusterMenuAnchorEl);

    // --- Handlers for the "Add Cluster" Menu ---
  const handleAddClusterMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAddClusterMenuAnchorEl(event.currentTarget);
    };

    const handleAddClusterMenuClose = () => {
        setAddClusterMenuAnchorEl(null);
    };

    const handleAddClusterMenuItemClick = (path: string) => {
        navigate(path); // Make sure to use your correct routes
        handleAddClusterMenuClose(); // Close the menu after clicking an item
    };
    // --- End Handlers for "Add Cluster" Menu ---

    // --- IDs for Add Cluster Menu ---
    const addClusterButtonId = 'add-cluster-action-button';
    const addClusterMenuId = 'add-cluster-action-menu';
    // --- End IDs for Add Cluster Menu ---

	React.useEffect(() =>{
		const fetchData = async () => {
			try {
				const data = await queryGraphql(`
                        query Query {
						resourceStatuses {
							id
							currentStatus
							resourceId
						}
						}
					`);
				if(data.resourceStatuses){
					setUpdates(data.resourceStatuses);
					
				}
				}
				catch(e){
			console.log(e);
				}
	}
	fetchData();
	},[]);

	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const data = await queryGraphql(`
                        query{
                        clusters {
						id,
                        clusterName,
                        environment,
                        gcpProjectId,
                        clusterOwner{
						id,
						email,
						name,
						googleProfilePicture
						},
						region,
						status,
                        createdAt,
						applications{
						id,
						applicationName,
						}
						reasonForRejection,
						clusterApprover{
						id,
						name,
						googleProfilePicture
						}
                        }
                        }
					`);

				let clustersArr = data.clusters.map((e: any) => {
					let rand = Math.random() * 8;

					return {
						...e,
						// applications: Math.round(rand),
						clusterOwnerAvatar: e?.clusterOwner?.googleProfilePicture,
						clusterOwner: e?.clusterOwner?.name,
						// clusterOwner: e?.clusterOwner?.email,
						createdAt: new Date(Number(e.createdAt)).toISOString(),
					};
				});
				setClusters(clustersArr);
				searchOptions = clustersArr
					.map((e: any) => {
						return [
							{
								category: "clusterName",
								groupBy: "CLUSTER NAME",
								chipLabel: `Cluster Name: ${e.clusterName}`,
								dropdownLabel: e.clusterName,
							},
							{
								category: "environment",
								groupBy: "ENVIRONMENT",
								chipLabel: `Environment: ${e.environment}`,
								dropdownLabel: e.environment,
							},
							{
								category: "region",
								groupBy: "REGION",
								chipLabel: `Region: ${e.region}`,
								dropdownLabel: e.region,
							},
							{
								category: "gcpProjectId",
								groupBy: "GCP PROJECT ID",
								chipLabel: `GCP Project Id: ${e.gcpProjectId}`,
								dropdownLabel: e.gcpProjectId,
							},
							{
								category: "clusterOwner",
								groupBy: "OWNER",
								chipLabel: `Owner: ${e.clusterOwner}`,
								dropdownLabel: e.clusterOwner,
							},
						];
					})
					.flat();

				searchOptions = searchOptions.filter(
					(obj, index, self) =>
						index ===
						self.findIndex(
							(t) => t.category === obj.category && t.dropdownLabel === obj.dropdownLabel
						)
				);
				searchOptions.sort((a, b) => {
					if (a.groupBy > b.groupBy) return 1;
					if (a.groupBy < b.groupBy) return -1;
					if (a.dropdownLabel > b.dropdownLabel) return 1;
					if (a.dropdownLabel < b.dropdownLabel) return -1;
					return 0;
				});

				// setUsers(result.data.users);
				// setLoading(false);
			} catch (error) {
				// setError(error.message);
				// setLoading(false);
				console.log(error);
			}
		};

		fetchData();
	}, []);

	const deleteCluster = async (id: string) => {
		const data = await queryGraphql(
			`
					mutation DeleteCluster($deleteClusterId: String!) {
	  deleteCluster(id: $deleteClusterId) {
		id
	  }
	}
	`,
			{
				deleteClusterId: id,
			}
		);

		if (data.deleteCluster.id) {
			setClusters([...clusters.filter((e: any) => e.id != id)]);
		}
	};
	const handleFilterClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleFilterClose = () => {
		setAnchorEl(null);
	};

	const toggleColumnFilter = (column: string) => {
		setColumnFilters((prevFilters) => ({
			...prevFilters,
			[column]: !prevFilters[column],
		}));
	};

	const filteredClusters =
		searchQuery.length == 0
			? clusters
			: clusters.filter(
					(cluster: any) =>
						(searchQuery.filter((e) => e.category == "clusterName").length > 0
							? searchQuery
									.filter((e) => e.category == "clusterName")
									.map((e) => e.dropdownLabel.toLowerCase())
									.includes(cluster.clusterName.toLowerCase())
							: true) &&
						(searchQuery.filter((e) => e.category == "region").length > 0
							? searchQuery
									.filter((e) => e.category == "region")
									.map((e) => e.dropdownLabel.toLowerCase())
									.includes(cluster.region.toLowerCase())
							: true) &&
						(searchQuery.filter((e) => e.category == "gcpProjectId").length > 0
							? searchQuery
									.filter((e) => e.category == "gcpProjectId")
									.map((e) => e.dropdownLabel.toLowerCase())
									.includes(cluster.gcpProjectId.toLowerCase())
							: true) &&
						(searchQuery.filter((e) => e.category == "clusterOwner").length > 0
							? searchQuery
									.filter((e) => e.category == "clusterOwner")
									.map((e) => e.dropdownLabel.toLowerCase())
									.includes(cluster.clusterOwner.toLowerCase())
							: true) &&
						(searchQuery.filter((e) => e.category == "environment").length > 0
							? searchQuery
									.filter((e) => e.category == "environment")
									.map((e) => e.dropdownLabel.toLowerCase())
									.includes(cluster.environment.toLowerCase())
							: true)
			  );

	const filteredActiveClusters = filteredClusters.filter(
		(cluster: any) => cluster.status === "active"
	);
	const filteredPendingClusters = filteredClusters.filter(
		(cluster: any) => cluster.status === "pending"
	);
	const filteredRejectedClusters = filteredClusters.filter(
		(cluster: any) => cluster.status === "rejected"
	);

	
	return (
		<Box sx={{ display: "flex" }}>
			<MainDrawer index={"clusters"} />
			<Box
				component="main"
				// display="inline-block"
				sx={{
					flex: 1,
					bgcolor: "#fafafa",

					minHeight: window.innerHeight,
				}}
			>
				<MiniBot/>
				<Container maxWidth={false} disableGutters>
					<Box bgcolor="#FFFFFF" p={2} mb="18px">
						<Box
							sx={{
								display: "flex",
								justifyContent: "space-between",
								alignItems: "center",
								marginBottom: 1,
								mx: 2,
							}}
						>
							<Typography fontSize="22px" gutterBottom fontFamily="Gilroy-Bold">
								Clusters
							</Typography>
						

							{/* <Button
								variant="contained"
								color="primary"
								disabled={!isClusterOwner}
								sx={{
									backgroundColor: "black",
									color: "white",
									padding: "8px 24px",
									fontSize: "0.875rem",
									textTransform: "none",
								}}
								onClick={() => navigate("/clusters/add")}
							>
								<Typography fontSize="14px" fontFamily="Gilroy-Bold">
									Add New Cluster
								</Typography>
							</Button> */}

								    {/* === MODIFIED BUTTON START === */}
					<Box sx={{display:'flex', justifyContent:'center'}}>
                          <Button
                              id={addClusterButtonId} // Add ID
                                aria-controls={isAddClusterMenuOpen ? addClusterMenuId : undefined} // Add ARIA controls
                                aria-haspopup="true" // Add ARIA haspopup
                                aria-expanded={isAddClusterMenuOpen ? 'true' : undefined} // Add ARIA expanded state
                                variant="contained"
                                // color="primary" // Not needed due to explicit background color
                                disabled={!isClusterOwner}
                                sx={{
                                    backgroundColor: "black", // Keep your styles
                                    color: "white",
                                    padding: "8px 24px",
                                    fontSize: "0.875rem",
                                    textTransform: "none",
                                    '&:hover': { // Optional: Adjust hover if needed
                                        backgroundColor: '#333',
                                    }
                                }}
                                onClick={handleAddClusterMenuClick} // CHANGE onClick handler
                            >
                                <Typography fontSize="14px" fontFamily="Gilroy-Bold">
                                    {/* Optional: Change button text */}
                                    Add Cluster
                                </Typography>
                            </Button>
                            {/* === MODIFIED BUTTON END === */}

							         {/* === ADDED MENU FOR THE BUTTON START === */}
                            <Menu
                                id={addClusterMenuId} // Add ID
                                MenuListProps={{
                                    'aria-labelledby': addClusterButtonId, // Link to button ID
                                }}
                                anchorEl={addClusterMenuAnchorEl} // Use specific anchor state
                                open={isAddClusterMenuOpen} // Use specific open state
                                onClose={handleAddClusterMenuClose} // Use specific close handler
                                // Optional positioning adjustments
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                            >
                                <MenuItem onClick={() => handleAddClusterMenuItemClick('/clusters/add/existing')}> {/* ADJUST PATH */}
                                    Add Existing Cluster
                                </MenuItem>
                                <MenuItem onClick={() => handleAddClusterMenuItemClick('/clusters/add')}> {/* ADJUST PATH */}
                                    Add New Cluster
                                </MenuItem>
								 {/* <MenuItem onClick={() => handleAddClusterMenuItemClick('/clusters/aws/add')}> 
                                    Add New Cluster (AWS)
                                </MenuItem> */}
                            </Menu>
							
							<IconButton
									  aria-label="Help" 
									  onClick={()=> window.open(`${process.env.REACT_APP_HOST_DOMAIN}/docs` , "_blank")}
									  sx={{
										padding: 0, 
										border: 'none',  
										ml:2,
										'&:hover': {
										  
										  backgroundColor: 'action.hover', 
										},
										
									  }}
									>
									  <Box
										component="img"
										src="/assets/Help.svg" 
										alt="" 
										sx={{
										  width: 40,  
										  height: 40,
										  display: 'block', 
										}}
									  />
									</IconButton>

</Box>

						</Box>
						<Divider sx={{ marginY: 1 }} />
						<Box sx={{ display: "flex", alignItems: "center", ml: 1 }}>
							<Autocomplete
								multiple
								options={searchOptions}
								filterSelectedOptions
								getOptionLabel={(option) => option.dropdownLabel}
								defaultValue={[]}
								groupBy={(option) => option.groupBy}
								renderTags={(tagValue, getTagProps) => {
									return tagValue.map((option, index) => (
										<Chip {...getTagProps({ index })} size="small" label={option.chipLabel}  />
									));
								}}
								onChange={(e, newVal, reason) => {
									setSearchQuery(newVal);
								}}
								renderInput={(params) => (
									<TextField
										{...params}
										variant="filled"
										placeholder="Search by cluster name, environment, owner etc"
										fullWidth
										size="small"
										hiddenLabel
										InputProps={{
											...params.InputProps,
											startAdornment: (
												<>
													<InputAdornment position="start">
														<img
															src="/assets/search-normal.svg"
															alt="Filter Icon"
															style={{ width: "16px", paddingLeft: "4px" }}
														/>
													</InputAdornment>
													{params.InputProps.startAdornment}
												</>
											),
											disableUnderline: true,
											style: {
												backgroundColor: "#f4f4f4",
												minHeight: "45px",
												width: "500px",
												borderRadius: "8px",
												fontFamily: "Gilroy-Regular",
												fontSize: "14px",
											},
										}}
									/>
								)}
							/>

							<Button
								sx={{
									marginLeft: "16px",
									border: "1px solid #bbb",
									borderRadius: "10px",
									height: "45px",
									width: "45px",
								}}
								onClick={handleFilterClick}
							>
								<img src="/assets/pause.svg" alt="Filter Icon" style={{ width: "16px" }} />
							</Button>
							<Menu
								anchorEl={anchorEl}
								open={Boolean(anchorEl)}
								onClose={handleFilterClose}
								anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
							>
								<Box sx={{ padding: "8px" }}>
									<Typography sx={{ fontWeight: "bold", marginBottom: "8px" }}>
										TABLE COLUMNS
									</Typography>
									<FormGroup>
										{Object.keys(columnFilters).map((column) => (
											<FormControlLabel
												key={column}
												control={
													<Checkbox
														checked={columnFilters[column as keyof typeof columnFilters]}
														onChange={() => toggleColumnFilter(column)}
														sx={{
															color: "#000", // Black color for the checkbox
															"&.Mui-checked": {
																color: "#000", // Black color when checked
															},
															"& .MuiSvgIcon-root": {
																borderRadius: "50%", // Rounded shape for the checkbox icon
															},
														}}
													/>
												}
												label={
													column.charAt(0).toUpperCase() +
													column
														.slice(1)
														.replace(/([A-Z])/g, " $1")
														.trim()
												}
											/>
										))}
									</FormGroup>
									<Button
										variant="contained"
										onClick={handleFilterClose}
										sx={{
											marginTop: "8px",
											backgroundColor: "black",
											color: "white",
											width: "100%",
										}}
									>
										Apply
									</Button>
								</Box>
							</Menu>
						</Box>
					</Box>
					<Box m={2}>
						{filteredPendingClusters.length > 0 && (
							<Accordion
								defaultExpanded={filteredPendingClusters.length > 0 ? true : false}
								elevation={0}
								sx={{
									borderRadius: "8px",
									mb: "16px",
									"&:before": {
										display: "none",
									},
									bgcolor: "#fafafa",
								}}
								disabled={filteredPendingClusters.length == 0}
							>
								<AccordionSummary expandIcon={<ExpandMore />}>
									<Box sx={{ display: "flex", alignItems: "center" }}>
										<img
											src="/assets/clock.svg"
											alt="Pending Icon"
											style={{ width: "20px", marginRight: "8px" }}
										/>
										<Typography fontSize="16px" fontFamily="Gilroy-SemiBold">
											Pending Clusters ({filteredPendingClusters.length})
										</Typography>
									</Box>
								</AccordionSummary>
								<AccordionDetails>
									{filteredPendingClusters.length > 0 && (
										<ClustersTable
											clusters={filteredPendingClusters}
											columnFilters={columnFilters}
											deleteCluster={deleteCluster}
											type="pending"
											resourceStatuses={updates}
										/>
									)}
								</AccordionDetails>
							</Accordion>
						)}
						{filteredActiveClusters.length > 0 && (
							<Accordion
							defaultExpanded={true}
								elevation={0}
								sx={{
									borderRadius: "8px",
									mb: "16px",
									"&:before": {
										display: "none",
									},
									bgcolor: "#fafafa",
								}}
								disabled={filteredActiveClusters.length == 0}
							>
								<AccordionSummary expandIcon={<ExpandMore />}>
									<Box sx={{ display: "flex", alignItems: "center" }}>
										<img
											src="/assets/tickcircle.svg"
											alt="Active Icon"
											style={{ width: "20px", marginRight: "8px" }}
										/>
										<Typography fontSize="16px" fontFamily="Gilroy-SemiBold">
											Active Clusters ({filteredActiveClusters.length})
										</Typography>
									</Box>
								</AccordionSummary>
								<AccordionDetails>
									{filteredActiveClusters.length > 0 && (
										<>
											<ClustersTable
												clusters={filteredActiveClusters}
												columnFilters={columnFilters}
												deleteCluster={deleteCluster}
												type="active"
												resourceStatuses={updates}
											/>
										</>
									)}
								</AccordionDetails>
							</Accordion>
						)}

						{filteredRejectedClusters.length > 0 && (
							<Accordion
								elevation={0}
								sx={{
									borderRadius: "8px",
									"&:before": {
										display: "none",
									},
									bgcolor: "#fafafa",
								}}
								disabled={filteredRejectedClusters.length == 0}
							>
								<AccordionSummary expandIcon={<ExpandMore />}>
									<Box sx={{ display: "flex", alignItems: "center" }}>
										<img
											src="/assets/reject.svg"
											alt="Rejected Icon"
											style={{ width: "20px", marginRight: "8px" }}
										/>
										<Typography fontSize="16px" fontFamily="Gilroy-SemiBold">
											Rejected Clusters ({filteredRejectedClusters.length})
										</Typography>
									</Box>
								</AccordionSummary>
								<AccordionDetails>
									{filteredRejectedClusters.length > 0 && (
										<>
											<ClustersTable
												clusters={filteredRejectedClusters}
												columnFilters={columnFilters}
												deleteCluster={deleteCluster}
												type="rejected"
												resourceStatuses={updates}
											/>
										</>
									)}
								</AccordionDetails>
							</Accordion>
						)}
					</Box>
				</Container>
			</Box>
		</Box>
	);
};

export default ClusterPage;
